import { inject, Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { toObservable } from '@angular/core/rxjs-interop';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { AuthStore } from '../state/auth/auth.store';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  private authStore = inject(AuthStore);
  private router = inject(Router);

  canActivate(
    pathIfNotLoggedIn: string
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.getIsLoggedIn(pathIfNotLoggedIn);
  }

  canActivateChild(
    pathIfNotLoggedIn: string
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.getIsLoggedIn(pathIfNotLoggedIn);
  }

  private getIsLoggedIn(pathIfNotLoggedIn: string): Observable<boolean> {
    return toObservable(this.authStore.isLoggedIn).pipe(
      filter((isLoggedIn: boolean | null) => isLoggedIn !== null),
      map((isLoggedIn) => {
        if (!isLoggedIn) {
          this.router.navigateByUrl(pathIfNotLoggedIn);
          return false;
        } else {
          return true;
        }
      })
    );
  }
}
